import script from "./FamilyTreeBuilder.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyTreeBuilder.vue?vue&type=script&setup=true&lang=ts"

import "./FamilyTreeBuilder.vue?vue&type=style&index=0&id=1a6290a6&scoped=true&lang=scss"
import "./FamilyTreeBuilder.vue?vue&type=style&index=1&id=1a6290a6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6290a6"]])

export default __exports__